import { create } from "zustand";
import { persist } from "zustand/middleware";

export type AdminRole = "admin" | "moderator" | "support";
export interface AdminUser {
  email: string;
  role: AdminRole;
  createdAt: string;
}

interface State {
  user: AdminUser | null;
  signIn: (email: string, role: AdminRole) => void;
  signOut: () => void;
}

export const useAdminAuth = create<State>()(
  persist(
    (set) => ({
      user: null,
      signIn: (email, role) =>
        set({ user: { email, role, createdAt: new Date().toISOString() } }),
      signOut: () => set({ user: null }),
    }),
    { name: "stl-admin-auth" },
  ),
);
